export default __webpack_public_path__ + "static/media/banner_foro_xx.5099de1d.jpg";